// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3GS1e","inner":"Footer_inner__3YbyX","nextIcon":"Footer_nextIcon__1d07T","innerLeft":"Footer_innerLeft__1g_1l"};